export default __webpack_public_path__ + "static/media/complementary--buses-and-trucks--g1.d1b0d33f.png";